<!-- New html -->
<div class="header-section">
    <div class="header-wrap">
<div class="container-fluid">
    <nav class="navbar">
        <a class="navbar-brand" routerLink="/{{baseWord}}/integrations-list">
            <!-- <img src="../../assets/images/daton-logo.png" alt=""> -->
            <span class="daton-logo"></span>
            <div class="logo-separater"></div>
        </a>
    <div class="navbar-collapse">
        <ul class="navbar-nav header-component-navbar">
            <!-- <li class="nav-item {{(thisRoute == 'dashboard-new') ? 'active' : ''}}"><a routerLink="/{{baseWord}}/dashboard-new" title="Integrations" class="nav-link">Dashboard</a></li> -->
            <!-- <li class="nav-item {{(thisRoute == 'integrations-list') ? 'active' : ''}}"><a routerLinkActive ="active" routerLink="/{{baseWord}}/integrations-list" title="Integrations" class="nav-link">Overview</a></li> -->
            <li class="nav-item {{(thisRoute == 'integrations-list') ? 'active' : ''}}"><a routerLinkActive ="active" routerLink="/{{baseWord}}/integrations-list" title="Sources" class="nav-link">Sources</a></li>
            <li class="nav-item {{(thisRoute == 'destinations-list') ? 'active' : ''}}"><a routerLinkActive ="active" routerLink="/{{baseWord}}/destinations-list" title="Destinations" class="nav-link">Destinations</a></li>
            <li class="nav-item {{(thisRoute == 'connectors') ? 'active' : ''}}"><a routerLinkActive ="active" routerLink="/{{baseWord}}/connectors" title="Connectors" class="nav-link">Connectors</a></li>
            <!-- <li class="nav-item {{(thisRoute == 'logs') ? 'active' : ''}}"><a routerLink="/{{baseWord}}/logs" class="nav-link" title="Logs">Logs</a></li> -->
            <li class="nav-item {{(isAdminSel) ? 'active' : ''}} dropdown {{(adminDrpdn) ? 'show' : ''}}" *ngIf="({ userId: userId, userRole: userRole, hasAdminAccess: hasAdminAccess } |  enableFeature: routePathEnum.admin)" [matMenuTriggerFor]="menu">
                <a routerLinkActive ="active" id="navbardrop" class="nav-link" title="Admin">Admin <span class="caret"></span></a>
                <mat-menu #menu="matMenu" class="admin-menu">
                    <button mat-menu-item routerLink="/{{baseWord}}/admin" class="admin-menuitem">Old Admin</button>
                    <button mat-menu-item (click)="goToNewAdmin()" class="admin-menuitem">New Admin</button>
                    <button mat-menu-item (click)="goToDashboard()" class="admin-menuitem">Dashboard</button>
                  </mat-menu>
            </li>
            <!-- <li class="nav-item {{(thisRoute == 'alerts') ? 'active' : ''}}"><a routerLinkActive ="active" routerLink="/{{baseWord}}/alerts" title="Alerts" class="nav-link">Alerts</a></li> -->
            <!-- <li *ngIf="!isBetaUser" class="nav-item {{(thisRoute == 'notifications') ? 'active' : ''}}" ><a role="button" (click)='viewAllNotifications()' routerLinkActive ="active" routerLink="/{{baseWord}}/notifications" class="nav-link" title="Notifications">Notifications<span class="notif" [ngStyle]="{'visibility': (notificationCount !== 0) ? 'visible' : 'hidden'}"></span></a></li> -->
            <li class="nav-item {{(thisRoute == 'notifications') ? 'active' : ''}}" ><a role="button" (click)='viewAllNotifications()' routerLinkActive ="active" routerLink="/{{baseWord}}/alerts/inbox" class="nav-link" title="Alerts">Alerts<span class="tab-data-length" *ngIf="unreadAlertsErrorCount">{{ unreadAlertsErrorCount > 100 ? '100+' : unreadAlertsErrorCount }}</span></a></li>
            <li *ngIf="showTemplatesTab" class="nav-item" >
                <a role="button"
                (click)="onTemplatesTabClick()"
                [routerLink]="({
                    templateFeatureFlags: templateFeatureFlags
                  } | enableTemplateActions: {
                    featureFlags: {
                        'company': 'Yes'
                    },
                    operator: 'or'
                  }) ?  templateOrgURL : templateSarasURL" class="nav-link {{templateRoute === 'templates' ? 'active' : ''}}" title="Templates">Templates</a></li>
            <li *ngIf="({ userId: userId, userRole: userRole, hasCStudioAccess: hasCStudioAccess } |  enableFeature: routePathEnum.cstudio)" class="nav-item {{(thisRoute == 'studio') ? 'active' : ''}}" ><a role="button" routerLinkActive ="active" routerLink="/{{baseWord}}/studio" class="nav-link" title="Connector Studio">Connector Studio<span class="notif" [ngStyle]="{'visibility': (notificationCount !== 0) ? 'visible' : 'hidden'}"></span></a></li>
            <li *ngIf="{
                userId: userId, userRole: userRole, hasUserDashboardAccess: hasUserDashboardAccess
            } |  enableFeature: routePathEnum.dashboards" class="nav-item {{(thisRoute == routePathEnum.dashboards) ? 'active' : ''}}" ><a role="button" routerLinkActive ="active" routerLink="/{{baseWord}}/{{routePathEnum.dashboards}}" class="nav-link" title="Dashboards">Dashboards<span class="notif" [ngStyle]="{'visibility': (notificationCount !== 0) ? 'visible' : 'hidden'}"></span></a></li>
            <li class="nav-item" *ngIf="isDatonSetup" ><a role="button" routerLinkActive ="active" routerLink="/{{baseWord}}/ask-daton" class="nav-link" title="Ask Daton">Ask Daton</a></li>
        </ul>
        <!-- *ngIf="ifTrial && expireDays > 0" -->
        <span  class="banner-no-internet" *ngIf="noConnection">Please check your internet connection</span>
        <ng-container *ngIf="(showNewBillingDetailsLink == false) && ifTrial && expireDays > 0">
            <span class="subscription-text" >Your trial expires in {{expireDays }} day(s)</span>
            <button mat-button   class="upgrade-bttn tooltip hover-tooltip tooltip-sm" [routerLink]="oldPricingRoute">
                Upgrade
                <div class="tooltip-section fade-in">
                    <div  class="tooltip-body" >
                        Upgrade to paid version
                    </div>
                </div>
            </button>
        </ng-container>
        </div>
        <div class="navbar-right">
            <ul class="navbar-ul">
                <li class="ul-item navbar-icon-item">
                    <div id="newsfeed-launcher" class="newsfeed-launcher btn-icon">
                        <div class="tooltip-section fade-in">
                            <div class="tooltip-body">
                                Product Fruit News
                            </div>
                        </div>
                        <span class="newsfeed-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
                    </div>
                </li>
                <li class="ul-item navbar-icon-item">
                  <div class="app-switcher btn-icon tooltip hover-tooltip tooltip-sm" (click)="appSwitcher()">
                    <div class="tooltip-section fade-in">
                        <div  class="tooltip-body" >
                            App Switcher
                        </div>
                    </div>
                    <!-- <mat-icon class="mat-icon-rtl-mirror" svgIcon="appSwitcher"></mat-icon> -->
                    </div>
                </li>
                <li class="ul-item navbar-icon-item">
                    <a href="https://help.sarasanalytics.com/en_US/daton-get-started/how-to-get-started-with-daton-setup" target="_blank" class="ul-link tooltip hover-tooltip tooltip-sm">
                        <span class="iconsvg-book round-40 btn-icon"></span>
                        <div class="tooltip-section fade-in">
                            <div  class="tooltip-body" >
                                Documentation
                            </div>
                        </div>
                    </a>
                </li>
                <li class="ul-item navbar-icon-item">
                        <div mat-button class=" loudspr" >
                           <!-- <span class="update-bttn"></span> -->
                                <a href="https://help.sarasanalytics.com/2024/release-notes-%7C-jan-2024" target="_blank" class="ul-link tooltip hover-tooltip tooltip-sm">
                                    <mat-icon aria-hidden="false" aria-label="Example home icon" class="align-super btn-icon loudspeaker123">campaign</mat-icon>
                                    <div class="tooltip-section fade-in">
                                        <div  class="tooltip-body" >
                                            Release Notes
                                        </div>
                                    </div>
                                </a>

                            <!-- <div class="announcement"></div> -->
                            <!-- <div class="tooltip-section fade-in">tooltip hover-tooltip tooltip-sm
                                <div  class="tooltip-body" >
                                    Check new updates
                                </div>
                            </div> -->
                        </div>

                </li>
                <!-- #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu2"-->
                <li class="ul-item navbar-icon-item dropdown {{(notifications.length > 0)?'have-notifications':''}} {{ifNotificationDropdown?'show':''}}" (click)="toggle('notifications')" style="display: none;">
                    <a href="javascript:void(0)" class="ul-link alertbell tooltip hover-tooltip tooltip-sm ">
                        <span class="round-40 btn-icon have-notification-icon" [ngClass]="notifications.length ? 'isAnimating text-orange' : ''">
                            <svg id="bell" class="bell" xmlns="http://www.w3.org/2000/svg" width="20" height="40" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 46 47">
                                <path id="bell-dome" class="st0" d="M35.8 16.8c0-5.7-3.7-10.5-8.9-12.2.1-.2.1-.4.1-.6 0-2.2-1.8-4-4-4s-4 1.8-4 4c0 .2 0 .4.1.6-5.2 1.7-8.9 6.5-8.9 12.2C10.2 30 3 30 3 36c0 1 0 3 20 3s20-2 20-3c0-6-7.2-6-7.2-19.2z" fill="currentColor"/>
                                <defs>
                                  <clipPath id="clapper-mask">
                                    <path id="clapper-mask" d="M3 39v8h40v-8s-4 2.2-20 2.2S3 39 3 39z"/>
                                  </clipPath>
                                </defs>
                                <g clip-path="url(#clapper-mask)">
                                  <g id="clapper-group" class="st1" >
                                    <circle id="clapper" class="st2" cx="23" cy="41" r="6" fill="currentColor"/>
                                  </g>
                                </g>
                              </svg>
                        </span>
                        <span  class="iconsvg-bell round-40 btn-icon no-notification-icon"></span>
                        <!-- <span class="badge-notification"></span> -->

                        <div class="tooltip-section fade-in">
                            <div  class="tooltip-body" >
                              Notifications
                            </div>
                          </div>


                    </a>
                    <!-- notification dropdown -->
                    <div class="dropdown-menu  animated--grow-in dropdown-menu-right notificationdropdown">

                                <div class="row justify-content-between pb-2">
                                    <div class="col-auto"><h6 class="mb-0 HKGroteskSemiBold">Notifications <span class="text-gray-300">({{notifications.length}})</span></h6></div>
                                    <div class="col-auto" [hidden]="!notifications.length"><a href="javascript:void(0)" class="font-12" (click)="clearAllNotifications()">Clear all</a></div>
                                </div>


                            <ul class="dropdown-ul">
                                <ng-container *ngFor="let notification of notifications; let i = index">
                                        <li class="notification-title" *ngIf="ifTitle(notification, i)">{{notification.title}}</li>
                                        <!-- alert-{{getNotificationType(notification.type)}}"  -->
                                        <li class="dropdown-item"  (click)="$event.stopPropagation();">
                                                <!-- <div class="text-strong-2 mb-2">Source loading failed</div> -->
                                                <p class="font-13">{{notification.message}}</p>
                                                <div class="row justify-content-between">
                                                    <div class="col-auto">
                                                            <!-- text-{{getNotificationType(notification.type)}} -->
                                                        <i  class="fa {{getIcon(notification.type)}}   text-warning"></i>

                                                        <span class="light-small ml-2">{{notification.minsBack}}</span>

                                                    </div>
                                                    <div class="col-auto">
                                                        <a href="javascript:void(0)" class="font-12" (click)="close(notification, 'Yes')">Clear</a>
                                                    </div>
                                                </div>
                                            </li>

                                </ng-container>




                            </ul>
                            <div class="mt-2" *ngIf="notifications.length !== 0"> <button mat-stroked-button color="primary" class="btn-block" routerLink="/u/notifications">View all</button></div>

                            <!-- no notifications -->
                            <div class="no-notifications" *ngIf="notifications.length === 0">
                                <img src="../../assets/images/new/no-notification.png" alt="">
                                <h6>No notifications!</h6>
                                <div class="light-very-small">We’ll notify you once we have
                                    something for you</div>

                            </div>
                            <!-- no notifications end-->
                        </div>
                    <!-- notification dropdown end -->
                    <!-- <mat-menu #menu2="matMenu" class="mat-menu-notification">
                        <div  mat-menu-item class="notifications-all-block mat-list-item-word-wrap">
                            <div class="notifications-wrapper">
                                <div  class="notifications-dropdown-heading">
                                    <div class="notifications-dropdown-heading-text">Notifications</div>
                                    <div [hidden]="!notifications.length" class="clear-all" (click)="clearAllNotifications()">Clear all</div>
                                </div>
                                <div class="notification-messages-wrapper">
                                    <div  *ngFor="let notification of notifications" class="notification-each-wrapper">
                                        <div  class="notification-each" (click)="$event.stopPropagation();">
                                          <span class="notification-message">{{notification.message}}</span>
                                          <span class="notification-close clear-all" value="close" (click)="close(notification, 'Yes')">X</span>
                                          <div class="notification-bottom notification-bottom-{{notification.type | lowercase}}">
                                              {{notification.minsBack}}
                                          </div>
                                        </div>
                                    </div>
                                </div>
                                <div [hidden]="!notifications.length" (click)="menuTrigger.closeMenu()" class="view-all" routerLink="/u/notifications">View all</div>
                                <div *ngIf="!notifications.length" class="no-notif-block">No notifications</div>
                            </div>

                        </div>
                    </mat-menu> -->

                </li>

            <li class="ul-item  ul-profile  dropdown"  (click)="toggle('menu')" [ngClass]="profileDropdown ? 'show' : ''">
              <a href="javascript:void(0)" class="ul-link tooltip hover-tooltip tooltip-sm tooltip-br-sm">
               <span class="round-40 user-profile-name" [ngClass]="userPlanClass" >{{(userFirstName.charAt(0)).toUpperCase()}}</span>
                <app-chip *ngIf="userPlan" show="true" [userPlan]="userPlan"></app-chip>
                <div class="tooltip-section fade-in">
                  <div  class="tooltip-body" >
                    <span>Hello {{userFirstName}} {{userLastName}} </span><br>
                    <span >{{userEmail}}</span>
                  </div>
                </div>
              </a>
              <div class="avatar-menu dropdown-menu  animated--grow-in dropdown-menu-right">
                        <span class="dropdown-item">
                            <span class="HKGroteskSemiBold font-16">Hello {{userFirstName}} {{userLastName}} </span>
                            <span class="label-04 d-block">{{userEmail}}</span>
                        </span>
                        <div class="dropdown-divider"></div>
                        <!-- <a routerLink="/{{baseWord}}/account/profile" class="dropdown-item">Edit profile</a> -->
                        <a routerLink="/{{baseWord}}/account/profile" class="dropdown-item">Account settings</a>
                        <!-- <a [routerLink]="subscriptionsRoute" class="dropdown-item">Subscriptions</a>
                        <a [routerLink]="pricingRoute" class="dropdown-item">Pricing</a> -->
                        <a *ngIf="showNewBillingDetailsLink; else oldSubscriptionLink" [routerLink]="newSubscriptionRoute" class="dropdown-item">Subscriptions</a>
                        <ng-template #oldSubscriptionLink >
                            <a [routerLink]="oldSubscriptionRoute" class="dropdown-item">Subscriptions</a>
                        </ng-template>
                        <a *ngIf="showNewBillingDetailsLink; else oldPricingLink" [routerLink]="newPricingRoute" class="dropdown-item">Pricing</a>
                        <ng-template #oldPricingLink >
                            <a [routerLink]="oldPricingRoute" class="dropdown-item">Pricing</a>
                        </ng-template>
                        <a [href]="customerSupportLink" target="_blank" rel="noopener noreferrer" class="dropdown-item cr-pointer">Support</a>
                        <div class="dropdown-divider"></div>
                        <a href="https://sarasanalytics.com/t_c.html" target="_blank" class="dropdown-item">Terms of use</a>
                        <a href="https://sarasanalytics.com/privacy" target="_blank" class="dropdown-item">Privacy policy</a>
                        <div class="dropdown-divider"></div>
                        <a  (click)="logout()" class="dropdown-item cr-pointer">Sign out</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
    </div>
</div>
</div>

<!-- new html end -->
<div class="header-section" style="display: none;">
    <!--Navigation section -->
    <a class="logo-anchor" (click)="home($event)" href="javascript:void(0)"><img src="./assets/images/daton-logo.png"
      class="img-responsive logo-image"></a>
      <!-- <span *ngIf="ifBanner"
            class="banner">
            You don't have setup warehouse.
      </span> -->
      <!-- <span  class="banner-no-internet">Please check your internet connection</span> -->
      <!-- <span  class="support-widget" (click)="openSupportWidget()">support</span> -->

      <div class="header-menu-1">
        <div mat-button [matMenuTriggerFor]="menu" class="user-image-block">
            <img  src="../assets/images/user-image.jpeg"> <span class="login-user-name" title="{{userFirstName}} {{userLastName}}">{{userFirstName}} {{userLastName}}</span>
            <img class="drop-down-image" src="../assets/images/drop-down-arrow.svg">
        </div>

        <mat-menu #menu="matMenu" class="user-dropdown-menu">
                <div mat-menu-item class="user-dropdown-options" routerLink="/{{baseWord}}/account">My Account</div>
                <!-- <div mat-menu-item class="user-dropdown-options">BI solutions</div> -->
                <div mat-menu-item class="user-dropdown-options" (click)="logout()">Logout</div>
        </mat-menu>
    </div>

    <div class="header-menu-2">
        <!-- <div mat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu2" class="notifications-outer-wrapper">
            <div class="notifications-inner-wrapper" title="Notifications">
                <img [class.disabled]="!notifications.length" class="notifications-inner-wrapper-bell" src="../assets/images/notification.svg">
                <div [hidden]="!notifications.length">
                  <img class="notifications-inner-wrapper-dot" src="../assets/images/notification_active.svg">
                </div>
              </div>
        </div> -->

        <!-- <mat-menu #menu2="matMenu" class="mat-menu-notification">
            <div  mat-menu-item class="notifications-all-block mat-list-item-word-wrap">
                <div class="notifications-wrapper">
                    <div  class="notifications-dropdown-heading">
                        <div class="notifications-dropdown-heading-text">Notifications</div>
                        <div [hidden]="!notifications.length" class="clear-all" (click)="clearAllNotifications()">Clear all</div>
                    </div>
                    <div class="notification-messages-wrapper">
                        <div  *ngFor="let notification of notifications" class="notification-each-wrapper">
                            <div  class="notification-each" (click)="$event.stopPropagation();">
                              <span class="notification-message">{{notification.message}}</span>
                              <span class="notification-close clear-all" value="close" (click)="close(notification, 'Yes')">X</span>
                              <div class="notification-bottom notification-bottom-{{notification.type | lowercase}}">
                                  {{notification.minsBack}}
                              </div>
                            </div>
                        </div>
                    </div>
                    <div [hidden]="!notifications.length" (click)="menuTrigger.closeMenu()" class="view-all" routerLink="/u/notifications">View all</div>
                    <div *ngIf="!notifications.length" class="no-notif-block">No notifications</div>
                </div>

            </div>
        </mat-menu> -->
    </div>
</div>
